import React from 'react';
import { useRouter } from 'next/navigation';
import NavigationTabs from '@/components/navigation/NavigationTabs';
import SearchBox from '@/components/seo/search-area/SearchBox';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';
import { ACTIVE_TABS } from '@/constants/job-title';
import { JOB_TITLE_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { AuthContext, JobTitleContext } from '@/context/create-context';
import { SearchType } from '@/types/job-title';

type NavTabType = (typeof ACTIVE_TABS)[number] & { href?: string };

const Tabs = (props: {
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { selectedTab, setSelectedTab } = props;
  const {
    jobTitle: { id },
    isJobTitleCity,
  } = React.useContext(JobTitleContext);
  const { isLogin } = React.useContext(AuthContext);
  const observerRef = React.useRef<HTMLDivElement | null>(null);
  const router = useRouter();

  const activeTabs = React.useMemo<NavTabType[]>(() => {
    if (!isJobTitleCity) return ACTIVE_TABS;

    const tabs: NavTabType[] = ACTIVE_TABS.map((tab) => ({ ...tab }));
    const href = `${JOB_TITLE_PAGE_ROUTER_PATH}${id}/`;
    for (let i = 0; i < 3 && i < tabs.length; i++) {
      tabs[i].href = href;
    }
    return tabs;
  }, [isJobTitleCity, id]);

  const handleSearch = (value: SearchType) => {
    if (!value) return;
    router.push(
      `${JOB_TITLE_PAGE_ROUTER_PATH}${value.name_type == 'alias' ? (value.alias_id ? `${value.alias_id}/` : `${id}/?jn=${encodeURIComponent(value.name)}`) : `${value.id}/`}`,
    );
  };

  return (
    <>
      <div ref={observerRef} />
      <div
        className={`flex gap-x-10 sticky justify-between py-2 items-center z-[1101] bg-white top-0${isLogin ? '' : ' mx-[calc(50%-(50vw-var(--scrollbar-width)/2))] px-[calc((50vw-var(--scrollbar-width)/2)-50%)]'}`}
      >
        <NavigationTabs
          setSelectedTab={setSelectedTab}
          selectedTab={selectedTab}
          activeTabs={activeTabs}
          sticky={false}
          initObserverRef={observerRef}
          topOffset={BASE_HEADER_HEIGHT}
          useRemainSpace={true}
        />
        <div className="shrink-0 w-[300px]">
          <SearchBox
            enableAnimation={true}
            onChange={handleSearch}
            placeholder="搜索职位名称"
            noOptionsText="抱歉，暂未搜索到相关职位"
          />
        </div>
      </div>
    </>
  );
};

export default Tabs;
